import $http from "../../axios-intance";
import {Notification, MessageBox} from 'element-ui';

//Obtener los documentos
export async function fetchDocuments({commit, state, rootState}) {

    // if (!state.documents.length) {
    await $http.get(`/api/documentos?contact_id=${rootState.contacts.selectedContact.id}`)
        .then((response) => {
            commit('setDocuments', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('documentError', error.message)
        })
    // }
}

//Crear documento
export async function addDocument({commit, state, dispatch, rootState}, data) {

    state.selectedDocument.contact_id = rootState.contacts.selectedContact.id;
    console.log(data.file)

    await $http.post('/api/presupuesto-ventas', data)
        .then((response) => {
            const payload = response && response.data ? response.data : null;
            let messageTitle = 'Resultado de la importación';
            let type = 'success';
            let html = '';
            if (payload && typeof payload === 'object') {
                const inserted = payload.inserted !== undefined ? payload.inserted : 0;
                const totalErrors = Array.isArray(payload.errors) ? payload.errors.length : 0;
                const maxRows = 500;
                const rows = Array.isArray(payload.errors) ? payload.errors.slice(0, maxRows) : [];
                const note = totalErrors > maxRows ? `<div class="mb-2 text-muted">Mostrando ${rows.length} de ${totalErrors} errores.</div>` : '';
                const table = rows.length ? `
                    <table class="msgbox-table">
                        <thead>
                            <tr>
                                <th style="width:80px">Fila</th>
                                <th style="width:120px">Tipo</th>
                                <th>Mensaje</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rows.map(e => `<tr><td>${e.row ?? '-'}</td><td>${(e.type || '').toString()}</td><td>${(e.message || '').toString()}</td></tr>`).join('')}
                        </tbody>
                    </table>` : '';
                html = `
                    <div class="msgbox-summary">
                        <div class="summary-item"><span class="label">Registros insertados</span><span class="value success">${inserted}</span></div>
                        <div class="summary-item"><span class="label">Errores</span><span class="value warning">${totalErrors}</span></div>
                    </div>
                    ${note}
                    ${table}
                `;
                type = totalErrors > 0 ? 'warning' : 'success';
            } else {
                html = '<div>El documento ha sido cargado.</div>';
            }
            MessageBox.alert(html, messageTitle, {
                confirmButtonText: 'Aceptar',
                type,
                customClass: 'messagebox-large messagebox-modern',
                dangerouslyUseHTMLString: true
            });
            state.error = false
        })
        .catch((error) => {
            let title = 'Error';
            let type = 'error';
            let html = '';
            if (error.response && error.response.status == 422) {
                const data = error.response.data;
                if (data && Array.isArray(data.errors)) {
                    const totalErrors = data.errors.length;
                    const maxRows = 500;
                    const rows = data.errors.slice(0, maxRows);
                    const note = totalErrors > maxRows ? `<div class="mb-2 text-muted">Mostrando ${rows.length} de ${totalErrors} errores.</div>` : '';
                    const table = rows.length ? `
                        <table class="msgbox-table">
                            <thead>
                                <tr>
                                    <th style="width:80px">Fila</th>
                                    <th style="width:120px">Tipo</th>
                                    <th>Mensaje</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${rows.map(e => `<tr><td>${e.row ?? '-'}</td><td>${(e.type || '').toString()}</td><td>${(e.message || '').toString()}</td></tr>`).join('')}
                            </tbody>
                        </table>` : '';
                    html = `<div class="msgbox-summary">
                                <div class="summary-item"><span class="label">Errores</span><span class="value warning">${totalErrors}</span></div>
                            </div>${note}${table}`;
                } else {
                    html = '<div>Algunos campos no se registraron correctamente.</div>';
                }
            } else {
                html = (error.message || 'Error inesperado');
            }
            MessageBox.alert(html, title, {
                confirmButtonText: 'Aceptar',
                type,
                customClass: 'messagebox-large messagebox-modern',
                dangerouslyUseHTMLString: true
            })
            commit('documentError', error.message)
        })
}

//Consultar documento por id
export async function getDocument({commit, state}, id) {

    if (state.selectedDocument.id != id) {

        await $http.get(`/api/documentos/${id}`)
            .then((response) => {
                commit('setDocument', response.data.data)
            })
            .catch((error) => {
                Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                });
                commit('documentError', error.message)
            })
    }

}

//Descargar documento
export async function downloadDocument({}, documentObject) {
    await $http({
        url: documentObject.path,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', documentObject.name + '.' + documentObject.extension);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    })
}

//Actualizar documento
export async function updateDocument({commit, state, dispatch}) {

    await $http.put(`/api/documentos/${state.selectedDocument.id}`, state.selectedDocument)
        .then((response) => {
            Notification.success({
                title: 'Exito!',
                message: 'El documento ha sido actualizado',
                duration: 3000,
                customClass: 'notification-box',
            });
            commit('setActionDocuments', 'create')
            commit('resetSelectedDocument')
            dispatch('fetchDocuments')
            state.error = false
        })
        .catch((error) => {
            let message;

            if (error.response.status == 422) {
                message = "Algunos campos no se registraron correctamente"
            } else {
                message = error.message
            }

            MessageBox.alert(message, 'Error', {
                confirmButtonText: 'Aceptar',
                type: 'error'
            })

            commit('documentError', error.message)
        })
}


//Eliminar documento
export async function removeDocument({commit, dispatch}, document) {

    await $http.delete(`/api/documentos/${document.id}`)
        .then((response) => {
            Notification.success({
                title: 'Exito!',
                message: 'El documento ha sido eliminado',
                duration: 3000,
                customClass: 'notification-box',
            });
            dispatch('fetchDocuments')
        })
        .catch((error) => {
            MessageBox.alert(error.message, 'Error', {
                confirmButtonText: 'Aceptar',
                type: 'error'
            })

            commit('documentError', e.message)
        })
}


// Obtiene los tipos de documento
export async function fetchDocumentsTypes({dispatch, state, rootState, commit}) {
    if (!state.documentsTypes.length) {
        await dispatch('parameters/listParameter', {params: {idParamTable: 2, paginate: false}}, {root: true})//TODO: Determinar el idParamTable
        commit('setDocumentsTypes', mapParameters(rootState.parameters.parameters))
    }
}

export function documentChangePath({commit}, path) {
    commit('setDocumentPath', path)
}

//Función para mapear los parametros y retornarlos en un mismo formato para todos los select
function mapParameters(parameters) {
    return parameters.map(p => {
        return {value: p.id, label: p.name_parameter}
    })
}



// Descargar plantilla de presupuesto de ventas
export async function downloadTemplate({}) {
    await $http({
        url: '/api/presupuesto-ventas/plantilla',
        method: 'GET',
        responseType: 'blob'
    })
        .then(response => {
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Plantilla presupuesto de ventas.xlsx');
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);
            }, 0);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error && error.response && error.response.data && error.response.data.message ? error.response.data.message : (error.message || 'No se pudo descargar la plantilla'),
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

//Crear documento
export async function addIncentivesDocument({commit, state, dispatch, rootState}, data) {

    state.selectedDocument.contact_id = rootState.contacts.selectedContact.id;
    console.log(data.file)

    await $http.post('/api/presupuesto-incentivos', data)
        .then((response) => {
            const payload = response && response.data ? response.data : null;
            let messageTitle = 'Resultado de la importación';
            let type = 'success';
            let html = '';
            if (payload && typeof payload === 'object') {
                const inserted = payload.inserted !== undefined ? payload.inserted : 0;
                const totalErrors = Array.isArray(payload.errors) ? payload.errors.length : 0;
                const maxRows = 500;
                const rows = Array.isArray(payload.errors) ? payload.errors.slice(0, maxRows) : [];
                const note = totalErrors > maxRows ? `<div class="mb-2 text-muted">Mostrando ${rows.length} de ${totalErrors} errores.</div>` : '';
                const table = rows.length ? `
                    <table class="msgbox-table">
                        <thead>
                            <tr>
                                <th style="width:80px">Fila</th>
                                <th style="width:120px">Tipo</th>
                                <th>Mensaje</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rows.map(e => `<tr><td>${e.row ?? '-'}</td><td>${(e.type || '').toString()}</td><td>${(e.message || '').toString()}</td></tr>`).join('')}
                        </tbody>
                    </table>` : '';
                html = `
                    <div class="msgbox-summary">
                        <div class="summary-item"><span class="label">Registros insertados</span><span class="value success">${inserted}</span></div>
                        <div class="summary-item"><span class="label">Errores</span><span class="value warning">${totalErrors}</span></div>
                    </div>
                    ${note}
                    ${table}
                `;
                type = totalErrors > 0 ? 'warning' : 'success';
            } else {
                html = '<div>El documento ha sido cargado.</div>';
            }
            MessageBox.alert(html, messageTitle, {
                confirmButtonText: 'Aceptar',
                type,
                customClass: 'messagebox-large messagebox-modern',
                dangerouslyUseHTMLString: true
            });
            state.error = false
        })
        .catch((error) => {
            let title = 'Error';
            let type = 'error';
            let html = '';
            if (error.response && error.response.status == 422) {
                const data = error.response.data;
                if (data && Array.isArray(data.errors)) {
                    const totalErrors = data.errors.length;
                    const maxRows = 500;
                    const rows = data.errors.slice(0, maxRows);
                    const note = totalErrors > maxRows ? `<div class="mb-2 text-muted">Mostrando ${rows.length} de ${totalErrors} errores.</div>` : '';
                    const table = rows.length ? `
                        <table class="msgbox-table">
                            <thead>
                                <tr>
                                    <th style="width:80px">Fila</th>
                                    <th style="width:120px">Tipo</th>
                                    <th>Mensaje</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${rows.map(e => `<tr><td>${e.row ?? '-'}</td><td>${(e.type || '').toString()}</td><td>${(e.message || '').toString()}</td></tr>`).join('')}
                            </tbody>
                        </table>` : '';
                    html = `<div class="msgbox-summary">
                                <div class="summary-item"><span class="label">Errores</span><span class="value warning">${totalErrors}</span></div>
                            </div>${note}${table}`;
                } else {
                    html = '<div>Algunos campos no se registraron correctamente.</div>';
                }
            } else {
                html = (error.message || 'Error inesperado');
            }
            MessageBox.alert(html, title, {
                confirmButtonText: 'Aceptar',
                type,
                customClass: 'messagebox-large messagebox-modern',
                dangerouslyUseHTMLString: true
            });
            Notification.error({
                title: 'Error!',
                message: error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
            commit('documentError', error.message)
        })
    // }
}
